import React from "react";

export default function CareersPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100">
      <div className="max-w-3xl mx-auto py-16 px-4">
        <h1 className="text-4xl font-bold mb-4 text-gradient bg-gradient-to-r from-indigo-500 via-pink-500 to-purple-500 bg-clip-text text-transparent">Careers at Inflatein</h1>
        <p className="text-lg text-gray-700 mb-6">Join our mission to shape the future of AI-powered creativity. We’re looking for passionate, talented people to help us build the next generation of creative tools.</p>
        <h2 className="text-2xl font-semibold mt-8 mb-2">Open Positions</h2>
        <ul className="list-disc pl-6 text-gray-600 mb-4">
          <li>Frontend Engineer (React, Tailwind CSS)</li>
          <li>Backend Engineer (Python, FastAPI)</li>
          <li>AI/ML Researcher</li>
          <li>Product Designer</li>
          <li>Community Manager</li>
        </ul>
        <p className="text-gray-600">To apply, send your resume and a short introduction to <a href="mailto:careers@inflatein.com" className="text-indigo-600 underline">careers@inflatein.com</a>.</p>
      </div>
    </div>
  )
}
